import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const providerOptions = {
  element: '.modal-content',
  popover: {
    title: 'Selecting an Integration',
    description:
      'Choose the plugin you want to integrate from the options listed. If you don’t see your plugin, let us know so we can help get it added!',
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const closeButton = document.querySelector('.close');

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    }
  }
};

export const requestingNewProvider = {
  element: '.integration-note',
  popover: {
    title: 'Requesting a New Integration',
    description:
      'Don’t see the integration you need? Submit a request—we’re always exploring better ways to help our customers leverage their data.',
    side: 'top',
    align: 'center'
  }
};

export const clickAProvider = {
  element: 'div.integration-provider-modal-body.modal-body > div > div:nth-child(1)',
  popover: {
    title: 'Integration Cards',
    description:
      'Select an integration card to begin the configuration process. Each card represents a plugin available for connection.',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const provider = document.querySelector(
        'div.integration-provider-modal-body.modal-body > div > div:nth-child(1)'
      );

      if (provider) {
        provider.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
